import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { FootersModule } from '@app/blocks/footers/footers.module';
import { ActionsModule } from '@app/blocks/actions/actions.module';

import { ContactoRoutingModule } from './contacto-routing.module';
import { ContactoComponent } from './components/contacto/contacto.component';
import { ContactoFormComponent } from './components/contacto-form/contacto-form.component';
import { ContactoOtherChannelsComponent } from './components/contacto-other-channels/contacto-other-channels.component';

@NgModule({
  declarations: [
    ContactoComponent,
    ContactoFormComponent,
    ContactoOtherChannelsComponent
  ],
  imports: [SharedModule, FootersModule, ActionsModule, ContactoRoutingModule]
})
export class ContactoModule {}
